import { render } from "./BaseRequestFormBtn.vue?vue&type=template&id=0f55cc26&scoped=true"
import script from "./BaseRequestFormBtn.vue?vue&type=script&lang=js"
export * from "./BaseRequestFormBtn.vue?vue&type=script&lang=js"

import "./BaseRequestFormBtn.vue?vue&type=style&index=0&id=0f55cc26&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f55cc26"]])

export default __exports__